<template>
  <div class="page-shell">
    <AppHeader />

    <main class="main-section page-main">
      <router-view />
    </main>

    <AppFooter />
  </div>
</template>


<script>
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'

export default {
  name: "App",
  components: {
    AppHeader,

    AppFooter
  }
}
</script>

<style>
.page-shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.page-main {
  flex: 1 0 auto;
}
</style>
